"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateRecentRegionPayloadSchema = exports.DeleteRecentRegionPayloadSchema = void 0;
var zod_1 = require("zod");
exports.DeleteRecentRegionPayloadSchema = zod_1.z.object({
    target: zod_1.z.string().min(1, 'target is required'),
    regionCode: zod_1.z.string().min(1, 'regionCode is required'),
});
exports.CreateRecentRegionPayloadSchema = zod_1.z.object({
    target: zod_1.z.string().min(1, 'target is required'),
    regionCode: zod_1.z.string().min(1, 'regionCode is required'),
});
